import { render, staticRenderFns } from "./StoreDashboardTemplate.vue?vue&type=template&id=bbdb7882&scoped=true"
import script from "./StoreDashboardTemplate.vue?vue&type=script&lang=js"
export * from "./StoreDashboardTemplate.vue?vue&type=script&lang=js"
import style0 from "./StoreDashboardTemplate.vue?vue&type=style&index=0&id=bbdb7882&prod&lang=css"
import style1 from "./StoreDashboardTemplate.vue?vue&type=style&index=1&id=bbdb7882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdb7882",
  null
  
)

export default component.exports